import React, { Component } from 'react';
import vitlogo from '../../../assets/images/vit.png';
import viitlogo from '../../../assets/images/viit.png';
import vu from '../../../assets/images/vu.png';
import isi from '../../../assets/images/isi.png';

class Partners extends Component {
    render() {
        return (
            <div>
                <section className="academic-partener padding-default pd-de">
                    <div className="row">
                        <div className="col-md-3 col-sm-6 col-xs-12">
                            <p className="lead" >
                                <h5>Academic Partners</h5>
                            </p>
                        </div>
                        <div className="col-md-2 col-sm-6 col-xs-12  border-right">
                        <img src={vitlogo} alt="vitlogo" className="img-fluid" />
                        </div>
                        <div className="col-md-2 col-sm-6 col-xs-12  border-right">
                            <img  src={viitlogo} alt="viitlogo"  className="img-fluid" />
                        </div>
                        <div className="col-md-2 col-sm-6 col-xs-12  border-right">
                            <img src={vu} alt="vu" className="img-fluid" />
                        </div>
                        <div className="col-md-2 col-sm-6 col-xs-12">
                            <img src={isi} alt="isi" className="isi" />
                        </div>
                        <div className="col-md-1 col-sm-6 col-xs-12"  id="edu" />
                    </div>
                </section>
            </div >
        );
    }
}

export default Partners;